import { BehaviorSubject, Subject } from 'rxjs';

export class AutocompleteService {
  resetSearch = new Subject<void>();
  shouldResetSearch = new BehaviorSubject<boolean>(false);
  resetSearch$ = this.resetSearch.asObservable();

  triggerResetSearch(): void {
    if (this.shouldResetSearch.value) {
      this.resetSearch.next();
    }
  }
}
